export const LOADING_DATA_MSG = 'Loading Data';
export const EMPTY_ARRAY = [];
